import * as Yup from "yup";

export const initialValues = (data) => {
  return {
    ...data,
    ...data?.localized_data,
    category_ids:
      data?.categories?.map((c) => ({ label: c.name, value: c.id })) || [],
    for_whole_cart: data?.for_whole_cart || false,
    // presentation: data?.presentation,
  };
};

export const structure = (
  wrapsList,
  colorsList,
  shapeList,
  t,
  categories,
  fetchCategories,
  categoriesLoading,
  categoriesCount,
) => [
  {
    head: "",
    width: "100%",
    list: [
      {
        name: `en.name`,
        kind: "input",
        type: "text",
        label: `${t("wrappers_ribbon_colors.name_en")}*`,
        width: "47%",
        placeholder: t("wrappers_ribbon_colors.write_name_en"),
      },
      {
        name: `ar.name`,
        kind: "input",
        type: "text",
        label: t("wrappers_ribbon_colors.name_ar"),
        width: "47%",
        placeholder: t("wrappers_ribbon_colors.write_name_ar"),
      },
      {
        name: `presentation`,
        kind: "colorInut",
        type: "text",
        label: `${t("wrappers_ribbon_colors.pick_color")}*`,
        width: "47%",
        placeholder: t("wrappers_ribbon_colors.pick_color_placeholder"),
      },
      {
        name: `price`,
        kind: "input",
        type: "number",
        label: `${t("wrappers_ribbon_colors.price")}*`,
        width: "47%",
        placeholder: t("wrappers_ribbon_colors.write_price"),
        EndAdornment: <p style={{ fontSize: "18px", color: "#1A1A1A" }}>SAR</p>,
      },
      {
        name: `price_after_discount`,
        kind: "input",
        type: "number",
        label: `${t("wrappers_ribbon_colors.price_after_discount")}*`,
        width: "47%",
        placeholder: t("wrappers_ribbon_colors.write_price"),
        EndAdornment: <p style={{ fontSize: "18px", color: "#1A1A1A" }}>SAR</p>,
      },
      {
        name: `category_ids`,
        kind: "multiSelect",
        label: t("products.label_recommended_categories"),
        width: "47%",
        placeholder: t("products.placeholder_choose_categories"),
        options: categories,
        onOpen: categories?.length <= 1 && fetchCategories,
        isLoading: categoriesLoading,
        getList: fetchCategories,
        count: categoriesCount,
      },
      {
        name: `for_whole_cart`,
        kind: "checkbox",
        label: t("wrappers_wraps.for_whole_cart") || "For Whole Cart",
        width: "47%",
      },
    ],
  },
];

export const validationSchema = (wrapId) =>
  Yup.object({
    en: Yup.object().shape({
      name: Yup.string().required("Required"),
    }),
    price: Yup.number().required("required"),
    price_after_discount: Yup.number().required("required"),
    presentation: Yup.string().required("Required"),
    category_ids: Yup.array(),
    for_whole_cart: Yup.boolean(),
  });
